/**
 * SectionLabel — small numbered kicker above each V3 home section heading.
 * Visual: "01 — Votre contexte" with a thin cyan rule before the number.
 */
import React from 'react';

type Props = {
  num: string;
  label: string;
};

const SectionLabel = ({ num, label }: Props) => (
  <div className="sum-section-label">
    <span className="sum-section-label-rule" aria-hidden="true" />
    {num} — {label}
  </div>
);

export default SectionLabel;
